import styled from 'styled-components';
import { PageMeta, PageMetaValue, PageTitle } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import BuildingIcon from '@/assets/icons/companyIcon.svg?react';
import EyeIconComponent from '@/assets/icons/eyeIcon.svg?react';

interface IScrollElements {
  $scroll?: boolean;
}

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const SurveyName = styled(PageTitle)<IScrollElements>`
  transition: font-size 0.3s, line-height 0.3s;
  ${({ $scroll }: IScrollElements) =>
    $scroll
      ? `
      font-size: 20px;
      line-height: 28px;
    `
      : ''}
`;

export const SurveyOrganizationCont = styled(PageMeta)<IScrollElements>`
  overflow: hidden;
  transition: opacity 0.3s, max-height 0.3s;
  ${({ $scroll }: IScrollElements) => `
    opacity: ${$scroll ? 0 : 1};
    max-height: ${$scroll ? '0' : '20px'};
  `}
`;

export const CompanyIcon = styled(BuildingIcon)``;

export const ButtonsCont = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .ant-spin-spinning {
    display: inline-flex;

    .ant-spin-dot-item {
      ${({ theme }: IThemeProvider) => `
        background: ${theme.colors.neutral.primary[0]};
      `}
    }
  }
`;

export const OrganizationName = styled(PageMetaValue)``;

export const SurveyNameCont = HeaderRow;

export const EyeIcon = styled(EyeIconComponent)`
  margin-right: 8px;
`;

export const IconImg = styled.img`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const DarkButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
`;
